import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import "./chatList.css";
import ChatListItems from "./ChatListItems";

export default class ChatList extends Component {
  allChatUsers = [
    {
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTA78Na63ws7B7EAWYgTr9BxhX_Z8oLa1nvOA&usqp=CAU",
      id: 1,
      name: "SRV InfoTech",
      active: true,
      isOnline: true,
    },
    {
      image:
        "https://pbs.twimg.com/profile_images/1055263632861343745/vIqzOHXj.jpg",
      id: 2,
      name: "SRV InfoTech",
      active: false,
      isOnline: false,
    },
    {
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTQEZrATmgHOi5ls0YCCQBTkocia_atSw0X-Q&usqp=CAU",
      id: 3,
      name: "SRV InfoTech",
      active: false,
      isOnline: false,
    },
    {
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRZ6tM7Nj72bWjr_8IQ37Apr2lJup_pxX_uZA&usqp=CAU",
      id: 4,
      name: "SRV InfoTech",
      active: false,
      isOnline: true,
    },
    {
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRJo1MiPQp3IIdp54vvRDXlhbqlhXW9v1v6kw&usqp=CAU",
      id: 5,
      name: "SRV InfoTech",
      active: false,
      isOnline: false,
    },
    {
      image:
        "https://huber.ghostpool.com/wp-content/uploads/avatars/3/596dfc2058143-bpfull.png",
      id: 6,
      name: "SRV InfoTech",
      active: false,
      isOnline: true,
    },
    {
      image:
        "https://www.paintingcontest.org/components/com_djclassifieds/assets/images/default_profile.png",
      id: 7,
      name: "SRV InfoTech",
      active: false,
      isOnline: true,
    },
    {
      image:
        "https://auraqatar.com/projects/Anakalabel/media//vesbrand/designer4.jpg",
      id: 8,
      name: "SRV InfoTech",
      active: false,
      isOnline: false,
    },
    {
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSM6p4C6imkewkCDW-9QrpV-MMAhOC7GnJcIQ&usqp=CAU",
      id: 9,
      name: "SRV InfoTech",
      active: false,
      isOnline: true,
    },
    {
      image: "https://pbs.twimg.com/profile_images/770394499/female.png",
      id: 10,
      name: "SRV InfoTech",
      active: false,
      isOnline: true,
    },
  ];
  constructor(props) {
    super(props);
    this.state = {
      allChats: this.allChatUsers,
    };
  }
  render() {
    return (
      <div className="main__chatlist">
        {/* <button className="btn">
          <i className="fa fa-plus"></i>
          <span>New conversation</span>
        </button> */}
        <Row>
          <Col xl="12">
            <Row>
              <div className="inbox-categories">
                <Row>
                  <Col md="2">
                    <div
                      className="active-all"
                      data-toggle="tab"
                      data-target="#all"
                    >
                      {" "}
                      All{" "}
                    </div>
                  </Col>
                  <Col md="2">
                    <div
                      className="whatsapp"
                      data-toggle="tab"
                      data-target="#whatsapp"
                    >
                      {" "}
                      <span className="fab fa-whatsapp"></span>{" "}
                    </div>
                  </Col>
                  <Col md="2">
                    <div
                      className="facebook"
                      data-toggle="tab"
                      data-target="#facebook"
                    >
                      {" "}
                      <span className="fab fa-facebook"></span>{" "}
                    </div>
                  </Col>
                  <Col md="2">
                    <div
                      className="instagram"
                      data-toggle="tab"
                      data-target="#instagram"
                    >
                      {" "}
                      <span className="fab fa-instagram"></span>{" "}
                    </div>
                  </Col>
                  <Col md="2">
                    <div
                      className="twitter"
                      data-toggle="tab"
                      data-target="#twitter"
                    >
                      {" "}
                      <span className="fab fa-twitter"></span>{" "}
                    </div>
                  </Col>
                </Row>
              </div>
            </Row>
          </Col>
        </Row>
        {/* <div className="chatlist__heading">
          <h2>Chats</h2>
          <button className="btn-nobg">
            <i className="fa fa-ellipsis-h"></i>
          </button>
        </div> */}
        <div className="chatList__search">
          <div className="search_wrap">
            <input type="text" placeholder="Search Here" required />
            <button className="search-btn">
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div className="chatlist__items">
          {this.state.allChats.map((item, index) => {
            return (
              <ChatListItems
                name={item.name}
                key={item.id}
                animationDelay={index + 1}
                active={item.active ? "active" : ""}
                isOnline={item.isOnline ? "active" : ""}
                image={item.image}
              />
            );
          })}
        </div>
      </div>
    );
  }
}
